import { useIsPhone } from "../hooks/useIsPhone";
import WavefieldArt from "../components/svg/WavefieldArt";

export default function PeopleScreen() {
  const isPhone = useIsPhone();
  return (
    <section id="who-we-are" className="reveal section-people">
      <div className="content">
        <h2>The team that ships AI at scale.</h2>
        <p>
          Scaled AI Solutions, already flying at major airlines and logistics companies
        </p>
        <p>
          Our 40+ high talent-density team spans multiple continents and
          apprenticed at prestigious investment banks, analytics powerhouses,
          leading management consultancies, and tech disruptors.
        </p>
        <div className="people-facts" aria-label="Team highlights">
          <div className="people-fact">
            <strong>40+</strong>
            <span>Team Members</span>
          </div>
          <div className="people-fact">
            <strong>5+ Years</strong>
            <span>In Production</span>
          </div>
          <div className="people-fact">
            <strong>Global</strong>
            <span>Team Footprint</span>
          </div>
          <div className="people-fact">
            <strong>FTSE 100 &amp; Fortune 500</strong>
            <span>Clients</span>
          </div>
        </div>
        <div className="section-closer">
          Built by disruptors <span>|</span> who ship AI at scale
        </div>
      </div>

      <div className="illustration">
        {!isPhone && <WavefieldArt />}
      </div>
    </section>
  );
}
